/**
 * Structural type guards for the `ActivityHistoryTradeItem` union, shared
 * by the activity history and Signal feed surfaces. Pure module (no React /
 * provider imports) so platform-neutral helpers like `signalFeedRowSummary`
 * can use them without dragging in the OrbyProvider dependency tree.
 */
export function isTokenTrade(item) {
    return "accountAddress" in item && "amount" in item && "balanceImpact" in item;
}
export function isPerpTrade(item) {
    return "tradeId" in item && "symbol" in item && "venue" in item && "side" in item && "price" in item;
}
export function isPredictionTradeItem(item) {
    return "outcome" in item && "pnl" in item && !("orderId" in item);
}
export function isPredictionOrder(item) {
    return "orderId" in item && "outcome" in item && "venue" in item && !("tradeId" in item);
}
